import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TypographyNormal } from "../../../customComponent";

const MAX_PREVIEW_SIZE = 400;

const WizardContentPreview = ({ config, calculateLayoutGrid }) => {
  const { width, height, layerCount } = config;
  const { cssGridStyle, lastLayerStyle } = calculateLayoutGrid(config);

  const { t } = useTranslation("cms");

  let previewWidth, previewHeight;
  const aspectRatio = width / height;

  if (width >= height) {
    // Landscape or Square: Constrain by Max Width
    previewWidth = MAX_PREVIEW_SIZE;
    previewHeight = previewWidth / aspectRatio;
  } else {
    // Portrait: Constrain by Max Height
    previewHeight = MAX_PREVIEW_SIZE;
    previewWidth = previewHeight * aspectRatio;
  }

  const containerStyle = {
    width: `${previewWidth}px`,
    height: `${previewHeight}px`,
    position: "relative",
    border: "1px solid #ccc",
    backgroundColor: "#f0f0f0",
    margin: "20px 0",
  };

  const contentAreaStyle = {
    ...cssGridStyle, // Apply the calculated grid layout
    width: "100%",
    height: "100%",
  };

  const layerPlaceholders = Array.from({ length: layerCount });

  return (
    <Box>
      <h4>
        {t("formatWizard.previewLabel")}
        {width}x{height}
      </h4>
      <Box sx={{ pr: 3, width: "fit-content" }}>
        <Box sx={containerStyle}>
          <Box sx={contentAreaStyle}>
            {layerPlaceholders.map((_, index) => {
              const isLastLayer = index === layerCount - 1;
              const layerStyle = isLastLayer ? lastLayerStyle : {};

              return (
                <Box
                  key={index}
                  sx={{
                    border: "1px dashed #333",
                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    ...layerStyle,
                  }}
                >
                  <Box>
                    <TypographyNormal>
                      {t("formatWizard.layerLabel")}
                      {index + 1}
                    </TypographyNormal>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default WizardContentPreview;
